import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=db50eb16&scoped=true&"
import script from "./OffersView.vue?vue&type=script&lang=js&"
export * from "./OffersView.vue?vue&type=script&lang=js&"
import style0 from "./OffersView.vue?vue&type=style&index=0&id=db50eb16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db50eb16",
  null
  
)

export default component.exports